const lumiAsset = { url: "/assets/lumi-vanta.png" };
import { cn } from "@/lib/utils";

const sizeMap = {
  xs: "h-7 w-7",
  sm: "h-9 w-9",
  md: "h-12 w-12",
  lg: "h-16 w-16",
} as const;

interface Props {
  size?: keyof typeof sizeMap;
  className?: string;
  glow?: boolean;
}

export function LumiAvatar({ size = "sm", className, glow = true }: Props) {
  return (
    <span className={cn("relative inline-flex shrink-0", sizeMap[size], className)}>
      {glow && <span className="absolute inset-0 rounded-full bg-primary/25 blur-md" aria-hidden />}
      <img
        src={lumiAsset.url}
        alt="Lumi Vanta, your HeirWise learning companion"
        className="relative z-10 h-full w-full rounded-full border border-primary/30 object-cover shadow-sm"
        loading="lazy"
      />
    </span>
  );
}